import LocationsEmptyState from './LocationsEmptyState';

export default {
  ReactComponent: LocationsEmptyState,
};
